<div class="title">
  <span class="title estricta uppercase"> Comissões </span>
</div>

<div class="commissions-page">

    <!-- Componente de Filtro -->
    <app-commissions-report-filter
      [commissionTypes]="allCommissions"
      [loading]="loading"
      (filtersChanged)="onTypeComissionChanged($event)"
      (search)="filter()"
    ></app-commissions-report-filter>


    <div class="export-actions">
      <app-button *ngIf="hasPermissionToExportPdf" [disabled]="isExportingPdf" [loading]="isExportingPdf" (click)="exportPdfReport()" datacy="button-export-pdf">
        <span>
          Exportar PDF
        </span>
      </app-button>

      <app-button *ngIf="hasPermissionToExportExcel" [disabled]="isExportingExcel" [loading]="isExportingExcel" (click)="exportWorksheetReport()" datacy="button-export-xlxs">
        <span>
          Exportar Excel
        </span>
      </app-button>
    </div>
      <div class="table">
        <app-table [table]="table"
        (emitPaginatorChanged)="onPageChange($event)"
        (emitActionView)="viewDataDetails($event)">
        </app-table>
      </div>
  </div>
